<template>
    <div>
        <div v-show="!onChild">
            <table-title>转户协议列表</table-title>

            <!-- 查询 -->
            <div class="serach">
                <Form ref="formValidate" :label-width="125" inline>
                    <div>
                        <FormItem label="上游参与人">
                            <payee-select v-model="queryParams.fromMemberId" class="shrug" roleType="LEASEE"></payee-select>
                        </FormItem>
                        <FormItem label="下游参与人">
                            <payee-select v-model="queryParams.toMemberId" class="shrug" roleType="LEASEE"></payee-select>
                        </FormItem>
                        <FormItem label="标的物小类">
                            <target-type-select v-model="queryParams.targetType" />
                        </FormItem>
                        <Button type="primary" style="margin-left:20px" @click="getQuery">查询</Button>
                        <Button type="success" style="margin-left:20px" v-show="confirmButton" @click="onChild = true">新增</Button>
                    </div>
                </Form>
            </div>
            <!-- 列表 -->
            <div class="table">
                <data-grid ref="dg" :columns="cols" :queryParams="queryParams" paramsName="params" :pageNum="1" :pageSize="20" :queryUrl="queryUrl">
                    <template #default="{columns, data}">
                        <Table :columns="columns" :data="data" border stripe size="small" style="margin:10px">
                            <template slot-scope="{row}" slot="appointFrameRent">
                                <a href="javascript:;" class="hoverCollection" style="color: #2d8cf0" @click="goDetail(row.appointFrameRent)">{{row.appointFrameRent}}</a>
                            </template>
                        </Table>
                    </template>
                </data-grid>
            </div>
            <leaseholder-detail ref="holderDetailRef"></leaseholder-detail>
        </div>
        <frameTransAdd v-if="onChild" @on-finish="onFinish" />
    </div>
</template>
<script>
import tableTitle from '@/components/tableTitle/tableTitle.vue'

import dataGrid from '@/components/datagrid.vue';
import frameTransAdd from './component/frame-trans-add.vue';
import payeeSelect from '@/components/select/payee-select.vue';
import targetTypeSelect from '@/components/select/targetTypeSelect.vue';
import leaseholderDetail from '@/views/user-center/lease/leaseholder/component/leaseholderDetail.vue'
export default {
    components: {
        tableTitle,
        dataGrid,
        frameTransAdd,
        payeeSelect,
        targetTypeSelect,
        leaseholderDetail
    },
    data() {
        return {
            confirmButton: false,//新增按钮限制
            queryUrl: 'http://CORE-CONTRACT/messageService/queryService/queryFrameTransListByParam',
            cols: [
                { title: '转户协议ID', key: 'id' },
                { title: '转户协议名称', key: 'name' },
                { title: '模式', key: 'modeId', dict: ['ENUM_CORE-CONTRACT', 'frameTransEntity.TransMode'] },
                { title: '转户上游', key: 'fromMemberId', dict: ['bizObjects', 'member', true] },
                { title: '转户下游', key: 'toMemberId', dict: ['bizObjects', 'member', true] },
                { title: '标的物小类', key: 'targetType', dict: ['target', 'type', true] },
                { title: '代付租金单价(元/片)', key: 'transUnitRental' },
                { title: '代付服务费单价(元/片)', key: 'transUintService' },
                // {title: '指定框架协议', key: 'appointFrameRent' },
                { title: '指定框架协议', slot: 'appointFrameRent' },
            ],
            queryParams: {
                fromMemberId: "",
                toMemberId: "",
                targetType: ""
            },
            onChild: false,
        }
    },
    mounted() {
        this.getButton()

    },
    methods: {
        // 新增按钮权限
        getButton() {
            this.confirmButton = JSON.parse(sessionStorage.getItem('menuList')).some(item => item === 'frameTransListMenuNewButton');
        },
        getQuery() {
            this.$refs['dg'].loadFirstPage()
        },
        onFinish() {
            this.$refs['dg'].loadFirstPage()
            this.onChild = false;
        },
        goDetail(id) {
            this.$refs['holderDetailRef'].openModal(id)
        },
    }

}
</script>

<style lang="scss" scoped>
.hoverCollection:hover {
    text-decoration: underline;
}
</style>